import Autoplay, { AutoplayOptionsType } from 'embla-carousel-autoplay';
import { isE2ETesting } from 'utils/environment';

/**
 * Returns an Autoplay plugin for Embla carousel, or undefined during E2E testing.
 * This centralizes the E2E check to ensure all carousels consistently disable autoplay during tests.
 */
export const useAutoplayPlugin = (options: AutoplayOptionsType) => {
  if (isE2ETesting()) {
    return undefined;
  }
  return Autoplay(options);
};
